/* La Boîte à Jouets – choisir les articles à payer maintenant.
   Les articles décochés sont retirés juste avant le paiement, mis de côté,
   puis remis automatiquement dans le panier au retour sur la boutique. */
(function () {
  var SAVED_KEY = 'lbaj_articles_plus_tard';
  var UNCHECKED_KEY = 'lbaj_lignes_decochees';

  function readJSON(store, key, fallback) {
    try { return JSON.parse(store.getItem(key)) || fallback; } catch (e) { return fallback; }
  }
  function writeJSON(store, key, value) {
    try { store.setItem(key, JSON.stringify(value)); } catch (e) {}
  }
  function unchecked() { return readJSON(sessionStorage, UNCHECKED_KEY, []); }
  function setUnchecked(list) { writeJSON(sessionStorage, UNCHECKED_KEY, list); }

  function money(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  /* 1. Remettre dans le panier les articles mis de côté lors d'un paiement précédent */
  function restoreSaved() {
    var saved = readJSON(localStorage, SAVED_KEY, []);
    if (!saved.length) return;
    localStorage.removeItem(SAVED_KEY);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: saved })
    }).then(function () {
      if (location.pathname.indexOf('/cart') === 0) location.reload();
      else document.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch(function () { writeJSON(localStorage, SAVED_KEY, saved); });
  }

  /* 2. Ajouter une case à cocher sur chaque ligne du panier */
  function decorateRows() {
    var rows = document.querySelectorAll('cart-items-component tr[data-key]');
    var off = unchecked();
    var added = false;
    rows.forEach(function (row) {
      if (row.querySelector('.lbaj-select')) return;
      added = true;
      var key = row.getAttribute('data-key');
      var target = row.querySelector('.cart-items__details') || row.firstElementChild;
      if (!target) return;
      var label = document.createElement('label');
      label.className = 'lbaj-select';
      var box = document.createElement('input');
      box.type = 'checkbox';
      box.checked = off.indexOf(key) === -1;
      box.setAttribute('data-line-key', key);
      var txt = document.createElement('span');
      txt.textContent = 'Payer maintenant';
      label.appendChild(box);
      label.appendChild(txt);
      target.insertBefore(label, target.firstChild);
      row.classList.toggle('lbaj-later', !box.checked);
      box.addEventListener('change', function () {
        var list = unchecked().filter(function (k) { return k !== key; });
        if (!box.checked) list.push(key);
        setUnchecked(list);
        row.classList.toggle('lbaj-later', !box.checked);
        updateSummary();
      });
    });
    if (added) updateSummary();
  }

  /* 3. Afficher le total des articles cochés */
  var summaryTimer;
  function updateSummary() {
    clearTimeout(summaryTimer);
    summaryTimer = setTimeout(function () {
      var buttons = document.querySelectorAll('#checkout, [name="checkout"]');
      if (!buttons.length) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var off = unchecked();
          var later = cart.items.filter(function (i) { return off.indexOf(i.key) !== -1; });
          var total = cart.items.reduce(function (s, i) {
            return off.indexOf(i.key) === -1 ? s + i.final_line_price : s;
          }, 0);
          buttons.forEach(function (btn) {
            var note = btn.parentElement.querySelector('.lbaj-note');
            if (!note) {
              note = document.createElement('p');
              note.className = 'lbaj-note';
              btn.parentElement.insertBefore(note, btn);
            }
            var html = later.length
              ? '<strong>À payer maintenant : ' + money(total) + '</strong><br>' +
                later.length + ' article(s) décoché(s) resteront dans votre panier pour plus tard.'
              : '';
            if (note.innerHTML !== html) note.innerHTML = html;
          });
          document.querySelectorAll('#dynamic-checkout-cart, shopify-accelerated-checkout-cart').forEach(function (el) {
            var d = later.length ? 'none' : '';
            if (el.style.display !== d) el.style.display = d;
          });
        }).catch(function () {});
    }, 150);
  }

  /* 4. Au clic sur « Payer », mettre de côté les articles décochés */
  function onCheckout(event) {
    var btn = event.target.closest && event.target.closest('#checkout, [name="checkout"]');
    if (!btn) return;
    var off = unchecked();
    if (!off.length) return;
    event.preventDefault();
    event.stopPropagation();
    btn.disabled = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var later = cart.items.filter(function (i) { return off.indexOf(i.key) !== -1; });
        if (later.length === cart.items.length) {
          btn.disabled = false;
          alert('Cochez au moins un article à payer maintenant.');
          return;
        }
        if (!later.length) { setUnchecked([]); location.href = '/checkout'; return; }
        var saved = readJSON(localStorage, SAVED_KEY, []);
        var updates = {};
        later.forEach(function (i) {
          saved.push({ id: i.variant_id, quantity: i.quantity, properties: i.properties || {} });
          updates[i.key] = 0;
        });
        writeJSON(localStorage, SAVED_KEY, saved);
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          setUnchecked([]);
          location.href = '/checkout';
        });
      })
      .catch(function () { btn.disabled = false; });
  }

  document.addEventListener('click', onCheckout, true);
  document.addEventListener('submit', function (e) {
    var sub = e.submitter;
    if (sub && sub.matches('#checkout, [name="checkout"]') && unchecked().length) onCheckout({
      target: sub, preventDefault: function () { e.preventDefault(); }, stopPropagation: function () {}
    });
  }, true);

  function init() {
    restoreSaved();
    decorateRows();
    new MutationObserver(function () { decorateRows(); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
